import { Component, computed, input, model, output, signal } from "@angular/core";
import { DialogModule } from "primeng/dialog";
import { ButtonModule } from "primeng/button";
import { TagModule } from "primeng/tag";

import { FormsModule } from "@angular/forms";
import { SelectModule } from "primeng/select";
import { RadioButtonModule } from "primeng/radiobutton";
import { InputTextModule } from "primeng/inputtext";
import { TooltipModule } from "primeng/tooltip";
import { TextareaModule } from "primeng/textarea";
import { MultiSelectModule } from "primeng/multiselect";
import { AvatarModule } from "primeng/avatar";
import { IUser } from "../../../../Utils/_models/users.model";
import { ModerationActionFormComponent, ModerationActionPayload } from "../../../../shared/components/moderation-action-form/moderation-action-form.component";

export type StatusAction = "ban" | "suspend" | "active" | "deactivate";

export interface StatusActionPayload {
  action: StatusAction;
  user: IUser;
  reason?: string;
  emailSubject?: string;
  emailBody?: string;
  suspendDays?: number;
  suspendedServices?: string[];
  sendEmail?: boolean;
}

@Component({
  selector: "app-user-status-modal",
  standalone: true,
  imports: [
    FormsModule,
    DialogModule,
    ButtonModule,
    TagModule,
    RadioButtonModule,
    InputTextModule,
    SelectModule,
    TooltipModule,
    TextareaModule,
    MultiSelectModule,
    AvatarModule,
    ModerationActionFormComponent
],
  templateUrl: "./user-status-modal.component.html",
  styleUrl: "./user-status-modal.component.css"
})
export class UserStatusModalComponent {
  user = input<IUser | null>(null);
  visible = model<boolean>(false);
  onClose = output();
  onAction = output<StatusActionPayload>();

  handleAction(payload: ModerationActionPayload) {
    const userData = this.user();
    if (!userData) return;

    const actionPayload: StatusActionPayload = {
      action: payload.action as StatusAction,
      user: userData,
      reason: payload.reason,
      emailSubject: payload.emailSubject,
      emailBody: payload.emailBody,
      suspendDays: payload.suspendDays,
      suspendedServices: payload.suspendedServices,
      sendEmail: payload.sendEmail
    };

    this.onAction.emit(actionPayload);
    this.closeDialog();
  }

  closeDialog(): void {
    this.visible.set(false);
    this.onClose.emit();
  }

  fullName = computed(() => {
    const userData = this.user();
    if (!userData) return 'N/A';
    const firstName = userData.firstName?.trim() ?? '';
    const lastName = userData.lastName?.trim() ?? '';
    const name = `${firstName} ${lastName}`.trim();
    return name || 'N/A';
  });

  getProfileImage(): string | undefined {
    const photos = this.user()?.profilePhotos || [];
    if (photos.length === 0) return undefined;
    const primary = photos.find(p => p.isPrimary);
    return (primary || photos[0])?.signedUrl || undefined;
  }

  getInitials(): string {
    const userData = this.user();
    if (!userData || !userData.firstName) return "N/A";
    return `${userData.firstName[0]}${userData.lastName?.[0] || ''}`.toUpperCase();
  }

  getAvatarColor(): string {
    const colors = ["#857031", "#857031", "#857031"];
    const userData = this.user();
    if (!userData || !userData._id) return colors[0];
    const index = userData._id.charCodeAt(0) % colors.length;
    return colors[index];
  }
}

